import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import type { PriceValue } from '../../configurator/controls';

export function useRenderPrice(value?: PriceValue) {
  const { language } = useSettings();
  const { t } = useLingui();

  if (!value) {
    return '';
  }

  const price = new Intl.NumberFormat(language?.language, {
    style: 'currency',
    currency: value.currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 0
  }).format(value.price);

  return {
    fixed: price,
    from: t`From ${price}`,
    free: t`Free`,
    hidden: ''
  }[value.type];
}
